import React, { ChangeEvent } from "react";
import { ILoginService } from "../../services/LoginService";
import "./login.scss"

interface Props {
    onLoginSuccess(): void;
    loginService: ILoginService;
}
interface State {
    username: string;
    password: string;
    isLoginEnabled: boolean;
}
type KeysWithValsOfType<T, V> = keyof { [P in keyof T as T[P] extends V ? P : never]: P };

export default class Login extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            isLoginEnabled: false
        };
    }

    private handleLogin = async (evt: React.FormEvent) => {
        evt.preventDefault();
        const success = await this.props.loginService.login(this.state.username, this.state.password);
        if (success) {
            this.props.onLoginSuccess();
        }

    }


    private handleChange(fieldName: KeysWithValsOfType<State, string>) {
        return (evt: ChangeEvent<HTMLInputElement>) => {
            this.setState(oldState => {
                let state = {
                    ...oldState,
                    [fieldName]: evt.target.value,
                };
                state.isLoginEnabled = !!state.password && !!state.username;
                return state;
            });
        }
    }

    render() {
        return (
            <div className="login-component">
                <div className="container">
                    <div className="logobox">
                        <img src="imgs/logo.svg" alt="Logo" id="mainlogo" />
                    </div>
                    <form onSubmit={this.handleLogin} className="form-signin">
                        <input type="text"
                            className="form-control"
                            autoFocus
                            placeholder="username"
                            autoComplete="username"
                            name="username"
                            onChange={this.handleChange("username")}
                        />
                        <input type="password"
                            className="form-control"
                            placeholder="password"
                            autoComplete="current-password"
                            onChange={this.handleChange("password")}
                            name="password" />
                        <div style={{ marginTop: "25px" }} >
                            <button type="submit" className="btn btn-block btn-primary" disabled={!this.state.isLoginEnabled} > Login</button>
                        </div>
                    </form>
                </div >
            </div >
        );
    }
}
